/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Provider_ZaloInputs */

const vi_shop_account_provider_zalo = /** @type {(inputs: Shop_Account_Provider_ZaloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalo`)
};

/**

* @param {Shop_Account_Provider_ZaloInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_provider_zalo = /** @type {((inputs?: Shop_Account_Provider_ZaloInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Provider_ZaloInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_provider_zalo(inputs)
});